import React from 'react';
import { Plus, Edit } from 'lucide-react';
import { Th, Td } from '../WMSShared';

export default function CustomersTab({ customers, setEditItem, setForm, setModal }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold">Customers <span className="text-gray-400 font-normal text-base">({customers.length})</span></h2>
        <button onClick={() => { setEditItem(null); setForm({ city: 'Singapore' }); setModal('customer'); }}
          className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-600 shadow-sm">
          <Plus className="w-4 h-4" />Add Customer
        </button>
      </div>
      <div className="bg-white rounded-xl border shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50"><tr><Th>Customer</Th><Th>Email</Th><Th>Phone</Th><Th>Address</Th><Th>Orders</Th><Th>Total Spent</Th><Th>Actions</Th></tr></thead>
            <tbody className="divide-y">
              {customers.map(c => (
                <tr key={c.customer_id} className="hover:bg-gray-50">
                  <Td className="font-medium">{c.name}</Td>
                  <Td className="text-gray-500">{c.email}</Td>
                  <Td className="text-gray-500">{c.phone}</Td>
                  <Td className="text-xs text-gray-500 max-w-[200px] truncate">{c.address}, {c.postal_code}</Td>
                  <Td className="font-medium">{c.total_orders}</Td>
                  <Td className="font-semibold">S${(c.total_spent || 0).toLocaleString()}</Td>
                  <Td><button onClick={() => { setEditItem(c); setForm(c); setModal('customer'); }} className="p-1.5 rounded hover:bg-blue-50 text-gray-400 hover:text-blue-500"><Edit className="w-3.5 h-3.5" /></button></Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {customers.length === 0 && <div className="p-8 text-center text-gray-400">No customers yet</div>}
      </div>
    </div>
  );
}
